import React, { useId } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { useModal } from './ModalContext'
import styles from './styles/CustomModal.module.css'

export const CustomModal: React.FC = () => {
  const {
    isOpen,
    closeModal,
    modalContent,
    modalTitle,
    modalSize,
    fetchStates,
    alignLeft,
    disableClose,
    centered,
    darkBackdrop,
    guardaFechamento,
    modalDescription,
    contentClassName,
  } = useModal()

  const isLoading = Object.values(fetchStates).some((state) => state.isLoading)
  const descriptionId = useId()

  /*
   * X, Esc e backdrop passam pela guarda opt-in (ver `ModalContext`): se ela
   * devolver `false`, o modal fica aberto e quem a registrou confirma com o
   * usuário. Sem guarda registrada o comportamento é o de sempre.
   */
  const solicitarFechamento = () => {
    if (guardaFechamento && !guardaFechamento()) return
    closeModal()
  }

  return (
    <Modal
      className={modalSize}
      contentClassName={contentClassName}
      show={isOpen}
      onHide={solicitarFechamento}
      backdrop={disableClose ? 'static' : undefined}
      backdropClassName={darkBackdrop ? styles['dark-backdrop'] : undefined}
      keyboard={!disableClose}
      centered={centered}
      enforceFocus={false}
      aria-describedby={modalDescription ? descriptionId : undefined}
      style={alignLeft ? { marginLeft: 0, marginRight: 'auto', maxWidth: '600px' } : {}}
    >
      <Modal.Header closeButton={!disableClose}>
        <div>
          <Modal.Title>{modalTitle}</Modal.Title>
          {modalDescription && (
            <p id={descriptionId} className='text-muted fs-7 mt-1 mb-0'>
              {modalDescription}
            </p>
          )}
        </div>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <div className='text-center py-5'>
            <Spinner animation='border' role='status'>
              <span className='visually-hidden'>Carregando...</span>
            </Spinner>
            <p className='fw-bold mt-3'>Carregando os dados, por favor espere...</p>
          </div>
        ) : (
          modalContent
        )}
      </Modal.Body>
    </Modal>
  )
}
